import { Injectable, ElementRef, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

@Injectable()
export class ScreenService {
    constructor(@Inject(PLATFORM_ID) private platformId: Object) { }

    public isInViewState = (elementRef: ElementRef): string => {
        let isInViewState = 'hide';
        if (isPlatformBrowser(this.platformId)) {
            let offsetTop = elementRef.nativeElement.offsetTop;
            if (elementRef.nativeElement.offsetParent !== null) {
                let parent = elementRef.nativeElement.offsetParent;
                while (parent.offsetParent && parent.offsetParent !== null && parent.offsetParent.localName !== 'body') {
                    parent = parent.offsetParent;
                }
                offsetTop = offsetTop + parent.offsetTop;
            }
            const componentPosition = offsetTop;
            const scrollPosition = window.pageYOffset;
            const screenHeight = window.innerHeight;
            if (scrollPosition + screenHeight >= componentPosition) {
                isInViewState = 'show';
            }
        } else {
            isInViewState = 'show';
        }
        return isInViewState;
    }

    public isLargeScreen = (): boolean => {
        return this.isLessOrEqualThanScreenSize(991);
    }

    public isMediumScreen = (): boolean => {
        return this.isLessOrEqualThanScreenSize(767);
    }

    public isMobileScreen = (): boolean => {
        return this.isLessOrEqualThanScreenSize(575);
    }

    public hasScrolledPixels = (pixels: number = 250): boolean => {
        if (isPlatformBrowser(this.platformId)) {
            return document.body.scrollTop > pixels ||
                   document.documentElement.scrollTop > pixels;
        } else {
            return false;
        }
    }

    private isLessOrEqualThanScreenSize = (screenSize: number): boolean => {
        if (isPlatformBrowser(this.platformId)) {
            return window.innerWidth <= screenSize;
        } else {
            return false;
        }
    }
}
